module.exports = __webpack_public_path__ + "static/media/user.0ed66a7a.svg";